(function () {
  'use strict';

  var MAX_CONCURRENT = window.matchMedia('(max-width: 700px)').matches ? 2 : 4;
  var SAVE_DATA = !!(navigator.connection && navigator.connection.saveData);
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var AUTOPLAY_OK = !SAVE_DATA && !REDUCED;
  var playing = [];

  function attachSource(video) {
    if (video.dataset.srcAttached === '1') return;
    var src = video.dataset.src;
    if (!src) return;
    video.src = src;
    video.dataset.srcAttached = '1';
  }

  function stop(video) {
    var i = playing.indexOf(video);
    if (i > -1) playing.splice(i, 1);
    try { video.pause(); } catch (e) {}
    var card = video.closest('.fsbsw__card');
    if (card) card.classList.remove('is-playing');
  }

  function start(video) {
    if (playing.indexOf(video) > -1) return;
    while (playing.length >= MAX_CONCURRENT) stop(playing[0]);
    attachSource(video);
    playing.push(video);
    var p = video.play();
    if (p && typeof p.then === 'function') {
      p.then(function () {
        var card = video.closest('.fsbsw__card');
        if (card) card.classList.add('is-playing');
      }).catch(function () { stop(video); });
    } else {
      var card = video.closest('.fsbsw__card');
      if (card) card.classList.add('is-playing');
    }
  }

  function observeCards(root) {
    var videos = root.querySelectorAll('video[data-src]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.6) {
          if (AUTOPLAY_OK) start(v);
        } else {
          stop(v);
        }
      });
    }, { threshold: [0, 0.6, 1], rootMargin: '0px' });
    Array.prototype.forEach.call(videos, function (v) { io.observe(v); });
  }

  function wireRail(rail) {
    var row = rail.querySelector('.fsbsw__row');
    var prev = rail.querySelector('.fsbsw__nav--prev');
    var next = rail.querySelector('.fsbsw__nav--next');
    if (!row) return;

    function step() {
      var card = row.querySelector('.fsbsw__card');
      var w = card ? card.getBoundingClientRect().width + 14 : 240;
      return Math.max(w, Math.round(row.clientWidth * 0.8 / w) * w);
    }

    function syncNav() {
      if (!prev || !next) return;
      var max = row.scrollWidth - row.clientWidth - 2;
      prev.hidden = row.scrollLeft <= 2;
      next.hidden = row.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', function () {
      window.clearTimeout(row._navT);
      row._navT = window.setTimeout(syncNav, 80);
    }, { passive: true });
    window.addEventListener('resize', syncNav, { passive: true });
    syncNav();

    var down = false, startX = 0, startScroll = 0, moved = 0;
    row.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = 0; startX = e.pageX; startScroll = row.scrollLeft;
    });
    row.addEventListener('mousemove', function (e) {
      if (!down) return;
      var d = e.pageX - startX;
      if (Math.abs(d) > 4) { moved = Math.abs(d); row.scrollLeft = startScroll - d; e.preventDefault(); }
    });
    ['mouseup', 'mouseleave'].forEach(function (ev) {
      row.addEventListener(ev, function () { down = false; });
    });
    row.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);
  }

  function init(scope) {
    var walls = (scope || document).querySelectorAll('.fsbsw:not([data-fsbsw-ready])');
    Array.prototype.forEach.call(walls, function (wall) {
      wall.setAttribute('data-fsbsw-ready', '1');
      var rail = wall.querySelector('.fsbsw__rail');
      if (rail) wireRail(rail);
      observeCards(wall);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) playing.slice().forEach(stop);
  });
})();
